import { Action } from '@ngrx/store'
import * as AuthTypes from './auth.types'
import { Login } from './auth.interface'

export class LoginRequest implements Action {
  readonly type = AuthTypes.LOGIN_REQUEST
  constructor(public payload: any) {}
}

export class LoginSuccess implements Action {
  readonly type = AuthTypes.LOGIN_SUCCESS
  constructor(public payload: Login) {}
}

export class LoginFailure implements Action {
  readonly type = AuthTypes.LOGIN_FAILURE
  constructor(public payload: any) {}
}

export class LogoutRequest implements Action {
  readonly type = AuthTypes.LOGOUT_REQUEST
  constructor(public redirect: boolean = true) {}
}

export class LogoutSuccess implements Action {
  readonly type = AuthTypes.LOGOUT_SUCCESS
  constructor() {}
}

export class LogoutFailure implements Action {
  readonly type = AuthTypes.LOGOUT_FAILURE
  constructor(public payload: any) {}
}

export class RequestPasswordResetRequest implements Action {
  readonly type = AuthTypes.REQUEST_PASSWORD_RESET_REQUEST
  constructor(public payload: any) {}
}

export class RequestPasswordResetSuccess implements Action {
  readonly type = AuthTypes.REQUEST_PASSWORD_RESET_SUCCESS
  constructor(public payload: any) {}
}

export class RequestPasswordResetFailure implements Action {
  readonly type = AuthTypes.REQUEST_PASSWORD_RESET_FAILURE
  constructor(public payload: any) {}
}

export class PasswordResetRequest implements Action {
  readonly type = AuthTypes.PASSWORD_RESET_REQUEST
  constructor(public payload: any) {}
}

export class PasswordResetSuccess implements Action {
  readonly type = AuthTypes.PASSWORD_RESET_SUCCESS
  constructor(public payload: any) {}
}

export class PasswordResetFailure implements Action {
  readonly type = AuthTypes.PASSWORD_RESET_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = AuthTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class TwoFactorVerificationCodeSent implements Action {
  readonly type = AuthTypes.TWO_FACTO_VERIFICATION_CODE_SENT
  constructor(public payload: any) {}
}

export class SetDefaultData implements Action {
  readonly type = AuthTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | SetDefaultData
  | UpdateField
  | LoginRequest
  | LoginSuccess
  | LoginFailure
  | LogoutRequest
  | LogoutSuccess
  | LogoutFailure
  | RequestPasswordResetRequest
  | RequestPasswordResetSuccess
  | RequestPasswordResetFailure
  | PasswordResetRequest
  | PasswordResetSuccess
  | PasswordResetFailure
  | TwoFactorVerificationCodeSent
